export default __webpack_public_path__ + "static/media/collapse_dark.13de8819.svg";